import FreeFieldCategoryDetailApp from "FreeFieldCategory/detail/app";
import FreefieldCategoryListApp from "FreeFieldCategory/list/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const freeFieldCategoryRoute: RouteObject = {
  path: "freefieldcategory",
  children: [{
    path: ":mainArea",
    loader: () => viewModel,
    Component: FreefieldCategoryListApp,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: FreeFieldCategoryDetailApp,
  }]
};